module.exports = __webpack_public_path__ + "img/attendances.55f65ba2.svg";